export default {
    name: 'DeniedNotification',
    data() {
        return {}
    },
    mounted() {},
    methods: {

    }
}
